import xhr from 'xhr';
import { useLocalStorage } from '@schemeserve/global-utils';

/**
 * Responsible for collecting the user's site data obtained directly from the api.
 * Data is stored in localStorage and refreshed peridically.
 * @category API
 */
export class SiteDataHandler {
	/**
	 *
	 * @param {object} config
	 */
	constructor(config) {
		this.config = config;
		this.siteData = {};
		this.key = 'ss_site_data';
		this.siteSettings = {};
	}

	/**
	 * @method
	 * @async
	 */
	init = async () => {
		if (window.isLoggedIn) {
			useLocalStorage().setItem('ssIsPreLogin', false);
		} else {
			useLocalStorage().setItem('ssIsPreLogin', true);
			useLocalStorage().deleteKey('ssSiteSettings');
			useLocalStorage().setItem('ssHasLoggedInSiteData', false);
		}

		if (!useLocalStorage().hasKey(this.key)) {
			useLocalStorage().setItem('ssHasLoggedInSiteData', false);
			this.getNewSiteData();
		} else if (
			useLocalStorage().hasKey(this.key) &&
			useLocalStorage().getItem('ssIsPreLogin') === false &&
			useLocalStorage().getItem('ssHasLoggedInSiteData') !== true
		) {
			this.getNewSiteData();
			const date = new Date();
			date.setTime(date.getTime() + 1 * 3600 * 1000);
			useLocalStorage().setItemWithExpiryDate(
				'ssHasLoggedInSiteData',
				true,
				date.toISOString(),
			);
		}
		this.runUpdateCheck();
	};

	/**
	 * @method
	 */
	runUpdateCheck = () => {
		this.checkInterval = setInterval(() => {
			if (!useLocalStorage().hasKey(this.key)) {
				clearInterval(this.checkInterval);
				this.getNewSiteData();
			}
		}, 600000);
	};

	/**
	 * @method
	 * @async
	 */
	getNewSiteData = async () => {
		const { data } = await xhr.get('site');

		this.siteData = data;

		this.setSiteDataLocalStorage();
	};

	/**
	 * @method
	 */
	setSiteDataLocalStorage = () => {
		if (Object.keys(this.siteData.settings).length) {
			this.siteSettings = this.siteData.settings.reduce(
				(acc, { key, value }) => {
					acc[key] = value;
					return acc;
				},
				{},
			);
			delete this.siteData.settings;
		}

		if (this.siteData.accountRef) {
			this.siteSettings.AccountRef = this.siteData.accountRef.toLowerCase();
		}

		const date = new Date();
		date.setTime(date.getTime() + 1 * 3600 * 1000);

		useLocalStorage().setItemWithExpiryDate(
			this.key,
			this.siteData,
			date.toISOString(),
		);
		useLocalStorage().setItemWithExpiryDate(
			'ssSiteSettings',
			this.siteSettings,
			date.toISOString(),
		);

		if (this.config.onAfterSetLocalStorage) {
			this.config.onAfterSetLocalStorage(this.siteData);
		}
		this.runUpdateCheck();
	};
}

export default SiteDataHandler;
